import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-483cd7b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global hr-details" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "hr-load-error"
}
const _hoisted_4 = { class: "hr-error" }
const _hoisted_5 = { class: "hr-load-actions" }
const _hoisted_6 = { class: "hr-heading" }
const _hoisted_7 = { class: "page-title" }
const _hoisted_8 = { class: "hr-summary" }
const _hoisted_9 = { class: "hr-completion" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Email", -1))
const _hoisted_11 = { class: "hr-summary-address" }
const _hoisted_12 = {
  key: 0,
  class: "hr-error"
}
const _hoisted_13 = { class: "hr-notifications" }
const _hoisted_14 = {
  key: 0,
  class: "hr-mail-request"
}
const _hoisted_15 = {
  key: 0,
  class: "hr-mail-request-action"
}
const _hoisted_16 = {
  key: 0,
  id: "hr-mail-request-hint",
  class: "hr-mail-hint",
  role: "status"
}
const _hoisted_17 = { class: "hr-reminder-row" }
const _hoisted_18 = { id: "hr-reminder-label" }
const _hoisted_19 = { id: "hr-reminder-hint" }
const _hoisted_20 = { class: "hr-switch" }
const _hoisted_21 = ["checked", "disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "hr-switch-track",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_23 = {
  key: 1,
  role: "status"
}
const _hoisted_24 = {
  key: 2,
  class: "hr-error",
  role: "alert"
}
const _hoisted_25 = { class: "hr-mail-history" }
const _hoisted_26 = { class: "hr-history-heading" }
const _hoisted_27 = {
  key: 0,
  class: "hr-mail-hint"
}
const _hoisted_28 = ["aria-label"]
const _hoisted_29 = { class: "hr-history-table" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 0,
  class: "hr-error"
}
const _hoisted_33 = { class: "hr-document-actions" }

import BackButton from "@/components/common/BackButton.vue";
import { computed, onMounted, ref } from "vue";
import HrEmployeeStatusBadge from "@/components/hr/HrEmployeeStatusBadge.vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { Button } from "@/components/common";
import Modal from "@/components/common/Modal.vue";
import HrDataService from "@/services/hr/HrDataService";
import HrNotificationModal from "@/components/hr/HrNotificationModal.vue";
import HrPersonalDocuments from "@/components/hr/HrPersonalDocuments.vue";
import HrAuditJournal from "@/components/hr/HrAuditJournal.vue";
import {
  HrEmployeeDetail,
  HrNotificationDelivery,
} from "@/types/hr/Hr";
import { AuthGetters } from "@/store/modules/auth";
import { getLocale, t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* Legacy ESLint does not detect template usage from script setup. */
/* eslint-disable @typescript-eslint/no-unused-vars */
const route = useRoute();
const router = useRouter();
const archiveOpen = ref(false);
const archiving = ref(false);
const archiveError = ref("");
const store = useStore();
const employee = ref<HrEmployeeDetail | null>(null);

const loading = ref(true);
const loadError = ref("");
const actionError = ref("");
const notificationOpen = ref(false);
const notificationMode = ref<"REQUEST" | "EXPIRY">("REQUEST");
const notificationBusy = ref(false);
const reminderBusy = ref(false);
const companyMailEnabled = ref<boolean | null>(null);
const mailSettingsLoading = ref(true);
const missingTypeIds = computed(() => (employee.value?.documents || []).filter(item => item.required && !(item.documents?.length || item.document)).map(item => item.documentTypeId));
const notificationSuccess = ref(false);
const notificationError = ref("");
const deliveries = ref<HrNotificationDelivery[]>([]);
const permissions = computed<string[]>(
  () => store.getters[AuthGetters.GET_USER_IDENTITY]?.permissions || []
);
const canEdit = computed(() => permissions.value.includes("HR_EMPLOYEE_EDIT"));
const canManageDocuments = computed(() =>
  permissions.value.includes("HR_DOCUMENT_MANAGE")
);
const canRequestDocuments = computed(
  () =>
    companyMailEnabled.value === true &&
    canEdit.value &&
    employee.value?.status === "ACTIVE" &&
    employee.value.completionPercentage < 100 &&
    missingTypeIds.value.length > 0
);
const mailRequestHint = computed(() => {
  if (mailSettingsLoading.value) return t("hr.mailSettingsChecking");
  if (companyMailEnabled.value === false) return t("hr.companyMailDisabledHint");
  if (companyMailEnabled.value === null) return t("hr.mailSettingsLoadError");
  return "";
});

async function load(initial = false) {
  if (initial || !employee.value) loading.value = true;
  loadError.value = "";
  try {
    const response = await HrDataService.getEmployee(String(route.params.id));
    employee.value = response.data.data;
    if (initial) await loadNotifications();
  } catch {
    if (employee.value) {
      actionError.value = t("hr.refreshError");
    } else {
      loadError.value = t("hr.employeeLoadError");
    }
  } finally {
    loading.value = false;
  }
}

function openNotifications(mode: "REQUEST" | "EXPIRY") {
  if (mode === "REQUEST" && !canRequestDocuments.value) return;
  notificationMode.value = mode;
  notificationSuccess.value = false;
  notificationOpen.value = true;
}
async function loadNotifications() {
  if (!employee.value || notificationBusy.value) return;
  notificationBusy.value = true;
  notificationError.value = "";
  const settingsLoading = loadMailSettings();
  try {
    const response = await HrDataService.getNotificationDeliveries(
      employee.value.id
    );
    deliveries.value = response.data.data;
  } catch (exception: unknown) {
    notificationError.value = apiErrorMessage(
      exception,
      t("hr.mailActionError")
    );
  } finally {
    await settingsLoading;
    notificationBusy.value = false;
  }
}
async function loadMailSettings() {
  companyMailEnabled.value = null;
  mailSettingsLoading.value = true;
  try {
    const response = await HrDataService.getNotificationSettings();
    if (
      !response.data.status ||
      typeof response.data.data?.enabled !== "boolean"
    ) {
      throw new Error("Invalid HR email settings response");
    }
    companyMailEnabled.value = response.data.data.enabled;
  } catch {
    companyMailEnabled.value = null;
  } finally {
    mailSettingsLoading.value = false;
  }
}
async function notificationsSaved() {
  notificationSuccess.value = true;
  await load();
  await loadNotifications();
}
async function toggleExpiry(event: Event) {
  const input = event.target as HTMLInputElement;
  if (!employee.value || reminderBusy.value || !canEdit.value) return;
  const previous = employee.value.expiryNotificationsEnabled;
  const enabled = input.checked;
  reminderBusy.value = true; notificationError.value = ""; notificationSuccess.value = false;
  try {
    await HrDataService.setExpiryNotifications([employee.value.id], enabled);
    employee.value.expiryNotificationsEnabled = enabled;
  } catch (exception: unknown) {
    notificationError.value = apiErrorMessage(exception, t("hr.mailActionError"));
  } finally {
    input.checked = employee.value?.expiryNotificationsEnabled ?? previous;
    reminderBusy.value = false;
  }
}
function formatNotificationDate(value: string) {
  const date = new Date(/[Z]|[+-]\d{2}:\d{2}$/.test(value) ? value : value + "Z");
  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleString(getLocale() === "en" ? "en-GB" : "ru-RU");
}
async function retryNotification(id: string) {
  if (notificationBusy.value || !window.confirm(t("hr.retryMailConfirm")))
    return;
  notificationBusy.value = true;
  notificationError.value = "";
  try {
    await HrDataService.retryNotification(id);
  } catch (exception: unknown) {
    notificationError.value = apiErrorMessage(
      exception,
      t("hr.mailActionError")
    );
    return;
  } finally {
    notificationBusy.value = false;
  }
  await loadNotifications();
}

function formatDate(value?: string) {
  return value ? new Date(`${value}T00:00:00`).toLocaleDateString() : "—";
}

function apiErrorMessage(exception: unknown, fallback: string) {
  const response = exception as { response?: { data?: { message?: string } } };
  return response.response?.data?.message || fallback;
}

async function archiveEmployee() {
  if (!employee.value || archiving.value) return;
  archiving.value = true; archiveError.value = "";
  try {
    await HrDataService.archiveEmployee(employee.value.id);
    archiveOpen.value = false;
    await router.push({ name: "HrEmployeeList" });
  } catch (exception: unknown) {
    archiveError.value = apiErrorMessage(exception, t("hr.saveError"));
  } finally { archiving.value = false; }
}
onMounted(() => load(true));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'HrEmployeeList' },
      "use-history": false,
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("hr.loading")), 1))
        : (loadError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(loadError.value), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Button), {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (load(true)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("hr.retry")), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : (employee.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(employee.value.fullName), 1),
                    _createElementVNode("p", null, _toDisplayString(employee.value.companyName || "—") + " · " + _toDisplayString(employee.value.jobName || "—"), 1),
                    _createVNode(HrEmployeeStatusBadge, {
                      status: employee.value.status
                    }, null, 8, ["status"])
                  ]),
                  (_unref(canEdit))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'HrEmployeeEdit', params: { id: employee.value.id } }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Button), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)("common.edit")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  (_unref(canEdit) && employee.value.status !== 'ARCHIVED')
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 1,
                        type: "button",
                        variant: "default",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (archiveOpen.value = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("hr.archive")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("strong", null, _toDisplayString(employee.value.requiredDocumentCount
              ? `${employee.value.completionPercentage}%`
              : "—"), 1),
                    _createElementVNode("span", null, _toDisplayString(employee.value.requiredDocumentCount
              ? _unref(t)("hr.completeness")
              : _unref(t)("hr.notConfigured")), 1)
                  ]),
                  _createElementVNode("dl", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("dt", null, _toDisplayString(_unref(t)("common.iin")), 1),
                      _createElementVNode("dd", null, _toDisplayString(employee.value.iin || "—"), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.personnelNumber")), 1),
                      _createElementVNode("dd", null, _toDisplayString(employee.value.personnelNumber || "—"), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_10,
                      _createElementVNode("dd", null, _toDisplayString(employee.value.email || "—"), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.phone")), 1),
                      _createElementVNode("dd", null, _toDisplayString(employee.value.phone || "—"), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.employmentType")), 1),
                      _createElementVNode("dd", null, _toDisplayString(employee.value.employmentType || "—"), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.hireDate")), 1),
                      _createElementVNode("dd", null, _toDisplayString(formatDate(employee.value.hireDate)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.residentialAddress")), 1),
                      _createElementVNode("dd", null, _toDisplayString(employee.value.residentialAddress || _unref(t)("hr.notSpecified")), 1)
                    ])
                  ])
                ]),
                (actionError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(actionError.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_13, [
                  (employee.value.completionPercentage < 100)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h2", null, _toDisplayString(_unref(t)("hr.employeeNotifications")), 1),
                          _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.requestDocumentsHint")), 1),
                          _createElementVNode("small", null, _toDisplayString(_unref(t)("hr.recipient")) + ": " + _toDisplayString(employee.value.email || _unref(t)("hr.emailMissingProfile")), 1)
                        ]),
                        (_unref(canEdit) && employee.value.status === 'ACTIVE')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_unref(Button), {
                                type: "button",
                                disabled: !_unref(canRequestDocuments),
                                "aria-describedby": 
                _unref(mailRequestHint) ? 'hr-mail-request-hint' : undefined
              ,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (openNotifications('REQUEST')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("hr.requestMissingDocuments")), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "aria-describedby"]),
                              (_unref(mailRequestHint))
                                ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_unref(mailRequestHint)), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", _hoisted_18, _toDisplayString(_unref(t)("hr.reminderLabel")), 1),
                      _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)("hr.reminderHint")), 1)
                    ]),
                    _createElementVNode("label", _hoisted_20, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        role: "switch",
                        "aria-labelledby": "hr-reminder-label",
                        "aria-describedby": "hr-reminder-hint",
                        checked: employee.value.expiryNotificationsEnabled,
                        disabled: !_unref(canEdit) || employee.value.status !== 'ACTIVE' || reminderBusy.value,
                        onChange: toggleExpiry
                      }, null, 40, _hoisted_21),
                      _hoisted_22,
                      _createElementVNode("span", null, _toDisplayString(reminderBusy.value
                ? _unref(t)("hr.saving")
                : employee.value.expiryNotificationsEnabled
                ? _unref(t)("hr.enabled")
                : _unref(t)("hr.disabled")), 1)
                    ])
                  ]),
                  (notificationSuccess.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_unref(t)("hr.notificationActionSaved")), 1))
                    : _createCommentVNode("", true),
                  (notificationError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(notificationError.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("details", _hoisted_25, [
                    _createElementVNode("summary", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("hr.notificationHistory")) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(deliveries.value.length), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.notificationHistoryHint")), 1),
                      _createVNode(_unref(Button), {
                        type: "button",
                        variant: "default",
                        disabled: notificationBusy.value,
                        onClick: loadNotifications
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(notificationBusy.value ? _unref(t)("hr.refreshing") : _unref(t)("hr.audit.refresh")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    (!deliveries.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_unref(t)("hr.noNotifications")), 1))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "hr-history-table-wrap",
                          tabindex: "0",
                          role: "region",
                          "aria-label": _ctx.$t('common.scrollableTable')
                        }, [
                          _createElementVNode("table", _hoisted_29, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.notificationDate")), 1),
                                _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.notificationReason")), 1),
                                _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.recipient")), 1),
                                _createElementVNode("th", null, _toDisplayString(_unref(t)("common.status")), 1),
                                _hoisted_30
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveries.value, (delivery) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: delivery.notificationId
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(formatNotificationDate(delivery.createdAt)), 1),
                                  _createElementVNode("td", null, _toDisplayString(delivery.type === "DOCUMENT_REQUEST"
                        ? _unref(t)("hr.documentRequestNotification")
                        : _unref(t)("hr.expiryReminderNotification")), 1),
                                  _createElementVNode("td", null, _toDisplayString(delivery.recipient || '—'), 1),
                                  _createElementVNode("td", null, [
                                    _createTextVNode(_toDisplayString(_unref(t)(`hr.delivery.${delivery.status}`)), 1),
                                    (delivery.reasonCode)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_unref(t)(`hr.deliveryReason.${delivery.reasonCode}`)), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", null, [
                                    (
                        _unref(canEdit) &&
                        (delivery.status === 'DEAD' ||
                          delivery.status === 'FAILED')
                      )
                                      ? (_openBlock(), _createBlock(_unref(Button), {
                                          key: 0,
                                          type: "button",
                                          variant: "default",
                                          disabled: notificationBusy.value,
                                          onClick: ($event: any) => (retryNotification(delivery.notificationId))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(t)("hr.retryDelivery")), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ], 8, _hoisted_28))
                  ])
                ]),
                _createVNode(HrPersonalDocuments, {
                  employee: employee.value,
                  "can-manage": _unref(canManageDocuments),
                  onChanged: _cache[3] || (_cache[3] = ($event: any) => (load()))
                }, null, 8, ["employee", "can-manage"]),
                _createVNode(HrAuditJournal, {
                  key: employee.value.id,
                  "employee-id": employee.value.id
                }, null, 8, ["employee-id"])
              ], 64))
            : _createCommentVNode("", true),
      (employee.value)
        ? (_openBlock(), _createBlock(HrNotificationModal, {
            key: 3,
            show: notificationOpen.value,
            "employee-ids": [employee.value.id],
            mode: notificationMode.value,
            "eligible-type-ids": _unref(missingTypeIds),
            onClose: _cache[4] || (_cache[4] = ($event: any) => (notificationOpen.value = false)),
            onSent: notificationsSaved
          }, null, 8, ["show", "employee-ids", "mode", "eligible-type-ids"]))
        : _createCommentVNode("", true),
      _createVNode(Modal, {
        show: archiveOpen.value,
        title: _unref(t)('hr.archiveEmployeeTitle'),
        onClose: _cache[6] || (_cache[6] = ($event: any) => (archiveOpen.value = false))
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.archiveEmployeeHint")), 1),
          (archiveError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(archiveError.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_unref(Button), {
              type: "button",
              variant: "default",
              disabled: archiving.value,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (archiveOpen.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.cancel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(Button), {
              type: "button",
              disabled: archiving.value,
              onClick: archiveEmployee
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(archiving.value ? _unref(t)("hr.archiving") : _unref(t)("hr.confirmArchiveEmployee")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      }, 8, ["show", "title"])
    ])
  ], 64))
}
}

})